export default __webpack_public_path__ + "static/media/Agent-Network-Locations-Banner.bcfc6905.png";